// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import type { StateType, DispatchType } from "../../../global/types/redux";
import { editFacebase } from "../../../admin/actions/facebaseAdminActions";
import { createFacebase } from "../../actions/companyActions";
import { hasPrincipal } from "../../../global/containers/UserAuth";
import CreateFacebaseForm from "../../components/facebases/CreateFacebaseForm";

type FacebaseItemReduxPropsType = {
  onClose: Function,
  openSnackbar: Function,
  facebase?: { [key: string]: * },
  company: { [key: string]: * },
  isAdmin?: boolean,
  isFacebaseAdmin?: boolean,
  companies?: Array<*>,
  currentUser: { [key: string]: * },
  actions: { editFacebase: Function, createFacebase: Function }
};

class CreateFacebaseFormRedux extends Component<FacebaseItemReduxPropsType, *> {
  editFacebase = (
    name: string,
    personLimit: string,
    online: boolean,
    newCompanyId: string,
    model: number,
    doneBack: Function,
    failBack: Function
  ): * => {
    this.props.actions.editFacebase(
      this.props.facebase.uuid,
      name,
      personLimit,
      online,
      newCompanyId,
      doneBack,
      failBack,
      this.props.company.uuid,
      this.props.isFacebaseAdmin
        ? "adminFacebase"
        : (this.props.isAdmin
          ? "adminCompany"
          : "company"),
      model
    );
  };

  createFacebase = (
    personLimit: string,
    online: boolean,
    name: string,
    model: number,
    doneCall: Function,
    failCall: Function
  ): * => {
    this.props.actions.createFacebase(
      personLimit,
      online,
      name,
      this.props.company.id,
      doneCall,
      failCall,
      model,
      this.props.isAdmin
    );
  };

  render(): React$Element<*> {
    const isImagusAdmin = hasPrincipal(
      "evaluation_licence_admin",
      this.props.currentUser.groups
    );
    const isLicenceAdmin = hasPrincipal(
      "licence_delegater",
      this.props.currentUser.groups
    );
    const demoOnly = !isImagusAdmin && !isLicenceAdmin;

    const canChangeModel = hasPrincipal(
      "imagus_admin",
      this.props.currentUser.groups
    );

    const companyList =
      this.props.companies &&
      this.props.companies.map(
        (company: { [key: string]: string }): * => ({
          value: company.uuid,
          label: company.name
        })
      );

    const modelList = [
      { value: 16, label: "V2 (16)" },
      { value: 4, label: "V1 (4)" }
    ];

    return (
      <CreateFacebaseForm
        onClose={this.props.onClose}
        openSnackbar={this.props.openSnackbar}
        facebase={this.props.facebase}
        company={this.props.company}
        companyList={companyList}
        demoOnly={demoOnly}
        canChangeModel={canChangeModel}
        modelList={modelList}
        createFacebase={this.createFacebase}
        editFacebase={this.editFacebase}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  currentUser: state.v3account.user
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchType => ({
  actions: bindActionCreators({ editFacebase, createFacebase }, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateFacebaseFormRedux);
